import { trpc } from '@/lib/trpc';
import { useTranslation } from 'react-i18next';
import { toast } from 'sonner';

const useDeleteList = () => {
	const { t } = useTranslation();
	const utils = trpc.useUtils();

	const { mutate, isPending, error } = trpc.list.delete.useMutation({
		onMutate: async (params) => {
			const successToast = toast.success(
				t('list.form.delete.notification')
			);

			await utils.list.get.cancel();

			const previousLists = utils.list.get.getData() || {
				status: 200,
				lists: [],
			};

			const optimisticLists = previousLists.lists.filter(
				(list) => list.id !== params.id_list
			);

			utils.list.get.setData(undefined, {
				status: 200,
				lists: optimisticLists,
			});

			return {
				previousLists,
				successToast,
			};
		},
		onError(_, __, context) {
			if (!context?.previousLists) return;
			utils.list.get.setData(undefined, {
				status: 200,
				lists: context?.previousLists.lists,
			});
			toast.dismiss(context.successToast);
			toast.error(t('error.generic'));
		},
	});

	return {
		deleteList: mutate,
		deleteLoading: isPending,
		deleteError: error,
	};
};

export default useDeleteList;
